import React from "react";
import { Container, createTheme, ThemeProvider } from "@material-ui/core";
import Navbar from "./components/navbar/Navbar";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Trending from "./pages/trending/Trending";
import Movies from "./pages/movies/Movies";
import Series from "./pages/series/Series";

import Header from "./components/Header";

import "./App.css";

const App = () => {
  const darkTheme = createTheme({
    palette: {
      type: "dark",
    },
  });
  return (
    <BrowserRouter>
      <ThemeProvider theme={darkTheme}>
        <Header />

        <Container>
          <Switch>
            <Route path="/" component={Trending} exact />
            <Route path="/movies" component={Movies} />
            <Route path="/series" component={Series} />
          </Switch>
        </Container>
        <Navbar />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
